import React from "react";

const CuponsPage = () => {
    return <div>Cupons</div>
}

export default CuponsPage;